import { message, Typography } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import { InventoryList } from 'components/models/inventories/InventoryList'
import { Loading } from 'components/shared/Loading'
import { useArtistsByOwnerId } from 'hooks/artists/useArtistsByOwnerId'
import { useOwnerInventories } from 'hooks/inventories/useOwnerInventories'
import { first, isEmpty } from 'lodash'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  owner: Owner
}

export const ArtworkListTab: FC<Props> = ({ owner }) => {
  const { xs } = useBreakpoint()
  const { t } = useTranslation()
  const router = useRouter()

  const searchObject = useMemo(() => {
    const params = new URLSearchParams(router.asPath.split(/\?/)[1])
    const searchObject = {}

    for (const key of Array.from(params.keys())) {
      if (key.includes('_in')) {
        Object.assign(searchObject, { [key]: params.getAll(key) })
      } else {
        Object.assign(searchObject, { [key]: params.get(key) })
      }
    }
    return searchObject
  }, [router.asPath])

  const ART_WORK_LIMIT = 18

  const {
    data,
    error: errorArtworks,
    isValidating,
    setSize,
  } = useOwnerInventories({
    ownerId: owner.id,
    limit: ART_WORK_LIMIT,
    search_params: searchObject,
  })
  const inventories = data?.flatMap((v) => v.inventoryData) || []

  const { data: artists = [], isValidating: isValidatingArtistsByOwnerId } =
    useArtistsByOwnerId(owner.id)

  const isDisplayEmptyStatus = isEmpty(errorArtworks) && isEmpty(artists)

  if (isValidatingArtistsByOwnerId) {
    return (
      <div style={{ paddingTop: xs ? 32 : 60 }}>
        <Loading />
      </div>
    )
  }

  if (isDisplayEmptyStatus) {
    return (
      <div
        style={{
          paddingTop: 100,
          paddingBottom: 100,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          rowGap: 24,
          justifyContent: 'center',
        }}
      >
        <Image src="/no-objects/artwork.png" width={130} height={130} />
        <Typography.Text style={{ fontSize: 16, lineHeight: 1 }}>
          {t('公開作品はありません')}
        </Typography.Text>
      </div>
    )
  }

  if (errorArtworks) {
    message.error(errorArtworks.data.error)
    return <></>
  }

  return (
    <div style={{ padding: xs ? '32px 16px 0px 16px' : '60px 64px 0px' }}>
      <InventoryList
        inventories={inventories}
        isValidating={isValidating}
        setSizeInventories={setSize}
        totalCount={first(data)?.xTotalCount || 0}
        xs={xs}
        artists={artists}
      />
    </div>
  )
}
